import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import utils from '@/slango-multiverse/helpers/utils';
import { globalProperties } from '@/main.js';
import { notifications } from '@/helpers/APIconnection';
export const NotificationsController = {
  GetNotificationsFromDehu: async function (selectedCerts) {
    if (!selectedCerts?.length) {
      globalProperties.$createToastMessage({
        key: 'no-certs',
        text: 'Necesitas seleccionar un certificado para continuar.',
        type: 'error',
        alive: 3000,
        fixed: true,
        close: false
      });
      return;
    }
    return await globalProperties.$desktopAppComunication("UpdateNotificationsList", selectedCerts);
  },
  GetNotifications: async function (notificationsQuery = {}, searchKeyword, filtersAsString) {
    const query = [];
    query.push(`sortby=${notificationsQuery.sortby}&sortdir=${notificationsQuery.sortdir}`);
    if (searchKeyword) {
      query.push(`search=${searchKeyword}`);
    }
    if (filtersAsString) {
      query.push(this.filtersAsString);
    }
    const queryString = query.length ? '?' + query.join('&') : '';
    const response = await notifications.get(queryString);
    if (response?.status === 200) {
      return response.data;
    }
  }
};
export default {
  data: function () {
    return {
      // >> View control config
      loading: {},
      view: {
        current: 'notifications',
        notifications: {
          title: 'Notificaciones'
        },
        configuration: {
          title: 'Configuración',
          description: 'Selecciona los certificados para actualizar sus notificaciones.',
          icon: {
            class: 'icon-previous text-xl cursor-pointer transition-transform hover:-translate-x-0.5',
            onclick: () => this.view.current = 'notifications'
          }
        }
      },
      // >> Data
      notificationsList: undefined,
      selectedCertificates: undefined,
      // >> Query data
      notificationsQuery: {
        sortby: 'titular',
        sortdir: 'desc'
      },
      notificationSearchKeyword: undefined,
      showNotificationFilters: false,
      filtersAsString: undefined,
      certificateSearchKeyword: undefined,
      context: {},
      filters: [{
        label: 'Fecha de Disposición',
        type: 'date-range',
        key: 'disposicion',
        onClear: this.applyFilters
      }, {
        label: 'Fecha de Caducidad',
        type: 'date-range',
        key: 'caducidad',
        onClear: this.applyFilters
      }],
      notificationProperties: [{
        label: 'Titular',
        key: 'titular'
      }, {
        label: 'Órgano emisor',
        key: 'organoEmisor'
      }, {
        label: 'Concepto',
        key: 'concepto'
      }, {
        label: 'Disposición',
        key: 'disposicion'
      }, {
        label: 'Caducidad',
        key: 'caducidad'
      }]
    };
  },
  mounted() {
    this.GetNotifications();
  },
  computed: {
    selectedCertificatesText() {
      const selected = this.selectedCertificates?.filter(c => c.selected)?.length;
      if (!selected) return;
      return selected > 1 ? `Certificados seleccionados: ${selected}` : 'Un certificado seleccionado';
    }
  },
  watch: {
    notificationSearchKeyword() {
      this.handleSpamOnNotificationsRequest();
    },
    filtersAsString() {
      this.handleSpamOnNotificationsRequest();
    }
  },
  methods: {
    handleSpamOnNotificationsRequest: function () {
      return utils.cancelableTimeout(this.context, 'get-notifications', 400, this.GetNotifications);
    },
    applyFilters: function () {
      this.filtersAsString = this.filters.map(f => f.toQuery()).join('&');
      this.handleSpamOnNotificationsRequest();
    },
    GetNotificationsFromDehu: async function () {
      const selectedCerts = this.selectedCertificates?.filter(c => c.selected);
      this.loading.scraping = true;
      await NotificationsController.GetNotificationsFromDehu(selectedCerts);
      this.GetNotifications();
      this.loading.scraping = false;
    },
    GetNotifications: async function () {
      this.loading.notifications = true;
      this.notificationsList = await NotificationsController.GetNotifications(this.notificationsQuery, this.notificationSearchKeyword, this.filtersAsString);
      this.loading.notifications = false;
    },
    changeSort: function (key) {
      if (this.notificationsQuery.sortby !== key) {
        this.notificationsQuery.sortby = key;
        this.notificationsQuery.sortdir = 'desc';
      } else {
        this.notificationsQuery.sortdir = this.notificationsQuery.sortdir === 'desc' ? 'asc' : 'desc';
      }
      this.handleSpamOnNotificationsRequest();
    }
  }
};